import { File, FileUploadService, UploadFileData } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useUploadFile(
  mutationOptions?: UseMutationOptions<File, HttpError, UploadFileData>,
) {
  return useMutation({
    mutationFn: FileUploadService.uploadFile,
    ...mutationOptions,
  });
}

export { useUploadFile };
